// LIBRERIE
import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef } from "react";

// HOOKS
import useInViewAnimation from "../../hooks/utilityStyle/useInViewAnimation";
import { Link } from "react-router-dom";

const Presentation: React.FC = () => {

    const { t } = useTranslation();

    const [pageReady, setPageReady] = useState(false);
    useEffect(() => {
        // Questo set time out è divuto al video che falsa lo posizione degli elemnti nel DOM finche non carica
        const timer = setTimeout(() => { 
            setPageReady(true);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    const ref1 = useRef<HTMLHeadingElement>(null);
    const ref2 = useRef<HTMLParagraphElement>(null);
    const allRefs: React.RefObject<HTMLHeadingElement | HTMLParagraphElement | null>[] = [ref1, ref2];
    useInViewAnimation({animationElementsRef: allRefs, animationClass: 'fade-in-left', pageReady: pageReady});

    return (
        <section id="presentation" className="space-pb mb-4 mb-lg-0">
            <div className="container-fluid w-special">
                <h2 className="mb-5 text-center" dangerouslySetInnerHTML={{ __html: t("homePage.presentation.title") as string }}></h2>
            </div>
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-12 col-lg-auto text-center mb-3 mb-lg-0 px-lg-0">
                        <img src="/assets/images/inHome/presentation.jpg" className="img-fluid" alt={t("homePage.presentation.altImg1") as string} />
                    </div>
                    <div className="col-12 col-lg px-lg-0">
                        <div className="text-wrapper">
                            <h3 className="mb-3">Rollo - Agenzia Immobiliare</h3>
                            <p dangerouslySetInnerHTML={{ __html: t("homePage.presentation.para1") as string }}></p>
                            <p dangerouslySetInnerHTML={{ __html: t("homePage.presentation.para2") as string }}></p>
                            <p dangerouslySetInnerHTML={{ __html: t("homePage.presentation.para3") as string }}></p>
                            <Link to="/chi-siamo" className="btn btn-primary mt-3" title={t("homePage.presentation.btnText") as string}>
                                {t("homePage.presentation.btnText")}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Presentation;